export enum FeatureSlug {
  RecurringInvoices = "recurring_invoices",
  Forms = "forms",
}

export interface Feature {
  name: string;
  slug: FeatureSlug;
  limit: number;
}

export interface FeaturePacks {
  name: string;
  slug: string;
  features: {
    data: Feature[];
  };
}

export interface Organization {
  code: string;
  name: string;
  sandbox: boolean;
  tag_line: string;
  email: string;
  phone: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  status: "active" | "inactive";
  role: "owner" | "admin" | "member";
  joined_at: string;
  image_url: string;
  stripe_account_id: string | null;
  settings: {
    data: {
      allow_partial_payment_for_invoices: boolean;
      pass_on_credit_card_fee: boolean;
      first_invoice_reminder: string;
      second_invoice_reminder: string;
      third_invoice_reminder: string;
      send_first_reminder: boolean;
      send_second_reminder: boolean;
      send_third_reminder: boolean;
      late_payment_surcharge: string | null;
      primary_interac_email_address: string | null;
      invoice_logo_url: string | null;
      timezone: string;
      working_days: number[];
      rate_lock_policy: "at_invoice" | "at_creation" | "none";
    };
  };
  feature_packs: {
    data: FeaturePacks[];
  };
  direct_features: {
    data: Feature[];
  };
  created_at: string;
  updated_at: string;
}
